module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsYearly@2x.06812f7.webp";